// Closed emphasis inside a tick sentence.
//
// Tick bodies stay markdown, not HTML: the pack writes `[words](https://…)`
// and the phone turns those into links. **Bold** and *italic* are the same
// idea at a smaller scale, so a counsel-edited sentence can stress a word
// without becoming a document body.

import type { ReactNode } from "react";

const EMPHASIS = /(\*\*([^*]+)\*\*|\*([^*]+)\*)/g;

/** **bold** and *italic* in already-plain text. Links are the caller's job. */
export function emphasizeTickText(text: string): ReactNode {
  const parts: ReactNode[] = [];
  let last = 0;
  let index = 0;
  for (const match of text.matchAll(EMPHASIS)) {
    const at = match.index ?? 0;
    if (at > last) parts.push(text.slice(last, at));
    if (match[2] !== undefined) {
      parts.push(<strong key={`b-${index}`}>{match[2]}</strong>);
    } else {
      parts.push(<em key={`i-${index}`}>{match[3]}</em>);
    }
    last = at + match[0].length;
    index += 1;
  }
  if (last < text.length) parts.push(text.slice(last));
  if (parts.length === 0) return text;
  return parts.length === 1 ? parts[0] : parts;
}
